import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiMapPin } from "react-icons/fi";
import "./TopLocations.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function LocationCard({ item }) {
  const navigate = useNavigate();
  const navigateHandler = () => {
    navigate("/listing?location=" + item?.title);
  };

  return (
    <div onClick={navigateHandler} className="tlCard">
      <img
        className="tlCard__img"
        src={apis().localUrl + item?.imageUrl}
        alt={item?.title}
        loading="lazy"
      />
      <div className="tlCard__overlay" />
      <div className="tlCard__content">
        <div className="tlCard__top">
          <span className="tlCard__badge">
            <FiMapPin /> {item?.city}
          </span>
          <span className="tlCard__arrow">
            <FiArrowUpRight />
          </span>
        </div>

        <div className="tlCard__name">{item?.title}</div>
        <div className="tlCard__meta"> Listings {item.listing?.length}</div>
      </div>
    </div>
  );
}

export default function TopLocations() {
  const [list, setList] = useState([]);
  
  const getTop = async () => {
    const data = {
      url: apis().getTopLocations,
    };
    const result = await httpAction(data);

    if (result?.status) {
      setList(result?.list);
    }
  };

  useEffect(() => {
    getTop();
  }, []);

  return (
    <section className="tl">
      <div className="container">
        <motion.div
          className="tl__head"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div>
            <span className="tl__kicker">Explore</span>
            <h2 className="tl__title">Top Locations</h2>
            <p className="tl__sub">
              Choose an area that matches your lifestyle and investment goals.
            </p>
          </div>

          {/* <button className="tl__cta" type="button">
            View All Areas <FiArrowUpRight />
          </button> */}
        </motion.div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]} // Ensure Autoplay module is added
          autoplay={{
            delay: 4000, // Set the desired autoplay duration (4000ms = 4 seconds)
            disableOnInteraction: false, // Autoplay continues even after user interaction
          }}
          pagination={{ clickable: true }}
          spaceBetween={16}
          slidesPerView={1} // Default to 1 slide visible at a time (mobile-first)
          breakpoints={{
            576: { slidesPerView: 1.1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 2.4 },
            1200: { slidesPerView: 3 },
          }}
          className="tl__swiper"
        >
          {list?.map((l, i) => (
            <SwiperSlide key={l?._id}>
              <motion.div
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.05 }}
              >
                <LocationCard item={l} />
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}